// extracted by mini-css-extract-plugin
module.exports = {"no_offers":"_02712f2b3b--no_offers--AcPbR","no_offers-content":"_02712f2b3b--no_offers-content--Zc1Yw","no_offers-text":"_02712f2b3b--no_offers-text--d0S9I"};